export default [
    {
        path: `/forms/entries/:formId`,
        component: () => import('@/pages/forms/index.vue')
    },
    {
        // Anonymous — `layout: blank` is required because Default.vue calls useMe().
        path: `/form/:slug`,
        component: () => import('@/pages/forms/PublicForm.vue'),
        meta: {
            layout: `blank`
        }
    }
]
